import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "./Hero_Landing_Page.css";

export default function HeroLandingPage({
    slides = [],
    badgeText,
    primaryBtn,
    secondaryBtn,
    autoSlideInterval = 5000,
}) {
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        if (slides.length <= 1) return;

        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, autoSlideInterval);
        return () => clearInterval(interval);
    }, [slides.length, autoSlideInterval]);

    if (!slides || slides.length === 0) {
        return null;
    }

    return (
        <div className="HLP-hero-carousel">
            {slides.map((slide, index) => (
                <div
                    key={index}
                    className={`HLP-hero-slide ${currentSlide === index ? "HLP-active" : ""
                        }`}
                >
                    <div className="HLP-hero-overlay"></div>
                    <img
                        src={slide.image}
                        alt={`Slide ${index + 1}`}
                        className="HLP-hero-image"
                    />

                    <motion.div
                        className="HLP-hero-text-content"
                        initial={{ opacity: 0, y: 30 }}
                        animate={
                            currentSlide === index
                                ? { opacity: 1, y: 0 }
                                : { opacity: 0, y: 30 }
                        }
                        transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
                    >
                        {(slide.badgeText || badgeText) && (
                            <div className="HLP-hero-badge">
                                {slide.badgeText || badgeText}
                            </div>
                        )}

                        <h1 className="HLP-hero-title">{slide.heading}</h1>

                        {slide.heading2 && (
                            <h1 className="HLP-hero-title">{slide.heading2}</h1>
                        )}

                        <p className="HLP-hero-subtitle">
                            {slide.subheading}
                        </p>

                        <div className="HLP-hero-buttons">
                            {primaryBtn && (
                                <a
                                    href={primaryBtn.link}
                                    className="HLP-btn-primary"
                                    style={{ textDecoration: "none" }}
                                    onClick={() => {
                                        if (window.fbq) {
                                            window.fbq('trackCustom', 'HeroButtonClicked', {
                                                button_text: primaryBtn.text,
                                                button_type: 'primary',
                                                link: primaryBtn.link
                                            });
                                            if (primaryBtn.text.toLowerCase().includes('demo')) {
                                                window.fbq('trackCustom', 'RequestDemoOpened', {
                                                    source: 'hero_primary'
                                                });
                                            }
                                        }
                                    }}
                                >
                                    {primaryBtn.text}
                                </a>
                            )}

                            {secondaryBtn && (
                                <a
                                    href={secondaryBtn.link}
                                    className="HLP-btn-secondary"
                                    style={{ textDecoration: "none" }}
                                    onClick={() => {
                                        if (window.fbq) {
                                            window.fbq('trackCustom', 'HeroButtonClicked', {
                                                button_text: secondaryBtn.text,
                                                button_type: 'secondary',
                                                link: secondaryBtn.link
                                            });
                                            if (secondaryBtn.text.toLowerCase().includes('demo')) {
                                                window.fbq('trackCustom', 'RequestDemoOpened', {
                                                    source: 'hero_secondary'
                                                });
                                            }
                                        }
                                    }}
                                >
                                    {secondaryBtn.text}
                                </a>
                            )}
                        </div>
                    </motion.div>
                </div>
            ))}
        </div>
    );
}
